import { render, staticRenderFns } from "./apuppt.vue?vue&type=template&id=55c6aa6b&scoped=true&"
import script from "./apuppt.vue?vue&type=script&lang=js&"
export * from "./apuppt.vue?vue&type=script&lang=js&"
import style0 from "./apuppt.vue?vue&type=style&index=0&id=55c6aa6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c6aa6b",
  null
  
)

export default component.exports